var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-dialog', {
    attrs: {
      "content-class": "app-dialog",
      "width": _vm.$vuetify.breakpoint.smAndDown ? '100%' : '520',
      "max-width": "520",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown
    },
    on: {
      "click:outside": _vm.closeDialog
    },
    model: {
      value: _vm.edit_dialog,
      callback: function ($$v) {
        _vm.edit_dialog = $$v;
      },
      expression: "edit_dialog"
    }
  }, [_c('ValidationObserver', {
    ref: "observer",
    staticClass: "d-flex flex-column",
    attrs: {
      "tag": "form"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var invalid = _ref.invalid;
        return [_c('v-form', [_c('v-card', [_c('v-card-title', {
          staticClass: "app-dialog-title"
        }, [_c('v-icon', {
          staticClass: "mr-2",
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("mdi-account-plus")]), _vm.edited_subject.id ? _c('span', [_vm._v("Edit subject \"" + _vm._s(_vm.edited_subject.name) + "\"")]) : _c('span', [_vm._v("Create new subject")])], 1), _c('v-card-text', {
          staticClass: "pt-4"
        }, [_c('v-text-field', {
          attrs: {
            "label": "Name",
            "required": "",
            "error": _vm.formErrors.name != null,
            "error-messages": _vm.formErrors.name
          },
          model: {
            value: _vm.edited_subject.name,
            callback: function ($$v) {
              _vm.$set(_vm.edited_subject, "name", $$v);
            },
            expression: "edited_subject.name"
          }
        }), _c('div', {
          staticClass: "d-flex align-start"
        }, [_c('ValidationProvider', {
          staticClass: "flex-grow-1",
          attrs: {
            "rules": _vm.weightValidationRules,
            "name": "Weight",
            "immediate": false
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref2) {
              var errors = _ref2.errors;
              return [_c('v-text-field', {
                attrs: {
                  "label": `Weight (${_vm.weightUnitLabel})`,
                  "type": "number",
                  "min": _vm.weightMin,
                  "step": _vm.weightStep,
                  "hide-spin-buttons": "",
                  "required": "",
                  "error": errors.length > 0 || !!_vm.weightWarningMessage,
                  "error-messages": errors[0] || _vm.weightWarningMessage
                },
                on: {
                  "wheel": function ($event) {
                    return $event.target.blur();
                  },
                  "keydown": _vm.restrictToNumbersAndDot
                },
                model: {
                  value: _vm.weightDisplay,
                  callback: function ($$v) {
                    _vm.weightDisplay = $$v;
                  },
                  expression: "weightDisplay"
                }
              })];
            }
          }], null, true)
        }), _c('v-select', {
          staticClass: "ml-2",
          staticStyle: {
            "max-width": "110px"
          },
          attrs: {
            "items": _vm.weightUnitOptions,
            "label": "Unit",
            "dense": "",
            "outlined": "",
            "hide-details": ""
          },
          model: {
            value: _vm.weight_unit,
            callback: function ($$v) {
              _vm.weight_unit = $$v;
            },
            expression: "weight_unit"
          }
        })], 1), _c('div', {
          staticClass: "d-flex align-start"
        }, [_c('ValidationProvider', {
          staticClass: "flex-grow-1",
          attrs: {
            "rules": _vm.heightValidationRules,
            "name": "Height",
            "immediate": false
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref3) {
              var errors = _ref3.errors;
              return [_c('v-text-field', {
                attrs: {
                  "label": `Height (${_vm.heightUnitLabel})`,
                  "type": "number",
                  "min": _vm.heightMin,
                  "step": _vm.heightStep,
                  "hide-spin-buttons": "",
                  "required": "",
                  "error": errors.length > 0,
                  "error-messages": errors[0]
                },
                on: {
                  "wheel": function ($event) {
                    return $event.target.blur();
                  },
                  "keydown": _vm.restrictToNumbersAndDot
                },
                model: {
                  value: _vm.heightDisplay,
                  callback: function ($$v) {
                    _vm.heightDisplay = $$v;
                  },
                  expression: "heightDisplay"
                }
              })];
            }
          }], null, true)
        }), _c('v-select', {
          staticClass: "ml-2",
          staticStyle: {
            "max-width": "110px"
          },
          attrs: {
            "items": _vm.heightUnitOptions,
            "label": "Unit",
            "dense": "",
            "outlined": "",
            "hide-details": ""
          },
          model: {
            value: _vm.height_unit,
            callback: function ($$v) {
              _vm.height_unit = $$v;
            },
            expression: "height_unit"
          }
        })], 1), _c('ValidationProvider', {
          attrs: {
            "rules": "required|birthYearRule",
            "name": "Birth Year",
            "immediate": false
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref4) {
              var errors = _ref4.errors;
              return [_c('v-text-field', {
                attrs: {
                  "label": "Birth year (yyyy)",
                  "type": "number",
                  "hide-spin-buttons": "",
                  "required": "",
                  "error": errors.length > 0,
                  "error-messages": errors[0]
                },
                model: {
                  value: _vm.edited_subject.birth_year,
                  callback: function ($$v) {
                    _vm.$set(_vm.edited_subject, "birth_year", $$v);
                  },
                  expression: "edited_subject.birth_year"
                }
              })];
            }
          }], null, true)
        }), _c('ValidationProvider', {
          attrs: {
            "rules": "required|subjectTagsRule",
            "name": "Subject Tags",
            "immediate": false
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref5) {
              var errors = _ref5.errors;
              return [_c('v-autocomplete', {
                ref: "subjectTagsSelect",
                attrs: {
                  "clearable": "",
                  "multiple": "",
                  "item-title": "text",
                  "item-value": "value",
                  "label": "Subject Tags",
                  "items": _vm.tagsOptions,
                  "error": errors.length > 0,
                  "error-messages": errors[0],
                  "search-input": _vm.tag_search_input
                },
                on: {
                  "update:searchInput": function ($event) {
                    _vm.tag_search_input = $event;
                  },
                  "update:search-input": function ($event) {
                    _vm.tag_search_input = $event;
                  },
                  "change": function ($event) {
                    _vm.tag_search_input = '';
                  }
                },
                model: {
                  value: _vm.edited_subject.subject_tags,
                  callback: function ($$v) {
                    _vm.$set(_vm.edited_subject, "subject_tags", $$v);
                  },
                  expression: "edited_subject.subject_tags"
                }
              })];
            }
          }], null, true)
        }), _c('v-select', {
          ref: "sexAtBirthSelect",
          attrs: {
            "clearable": "",
            "item-title": "text",
            "item-value": "value",
            "label": "Sex assigned at birth (Optional)",
            "items": _vm.sexesOptions
          },
          model: {
            value: _vm.edited_subject.sex_at_birth,
            callback: function ($$v) {
              _vm.$set(_vm.edited_subject, "sex_at_birth", $$v);
            },
            expression: "edited_subject.sex_at_birth"
          }
        }), _c('v-select', {
          ref: "genderSelect",
          attrs: {
            "clearable": "",
            "item-title": "text",
            "item-value": "value",
            "label": "Gender (Optional)",
            "items": _vm.gendersOptions
          },
          model: {
            value: _vm.edited_subject.gender,
            callback: function ($$v) {
              _vm.$set(_vm.edited_subject, "gender", $$v);
            },
            expression: "edited_subject.gender"
          }
        }), _c('v-textarea', {
          attrs: {
            "label": "Characteristics (Optional)",
            "rows": "3"
          },
          model: {
            value: _vm.edited_subject.characteristics,
            callback: function ($$v) {
              _vm.$set(_vm.edited_subject, "characteristics", $$v);
            },
            expression: "edited_subject.characteristics"
          }
        }), _c('div', {
          staticClass: "pt-0"
        }, [_c('ValidationProvider', {
          attrs: {
            "rules": {
              required: {
                allowFalse: false
              }
            },
            "name": "Informed consent selection"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref6) {
              var errors = _ref6.errors;
              return [_c('v-checkbox', {
                staticClass: "mt-0 mb-0",
                attrs: {
                  "error": errors.length > 0,
                  "error-messages": errors[0]
                },
                scopedSlots: _vm._u([{
                  key: "label",
                  fn: function () {
                    return [_c('div', [_vm._v("I, the research Participant, have provided informed consent to the research Investigator conducting this study. I have read and I agree to the "), _c('v-tooltip', {
                      attrs: {
                        "location": "bottom"
                      },
                      scopedSlots: _vm._u([{
                        key: "activator",
                        fn: function (_ref7) {
                          var props = _ref7.props;
                          return [_c('a', _vm._b({
                            attrs: {
                              "href": "https://www.opencap.ai/terms-conditions",
                              "target": "_blank"
                            },
                            on: {
                              "click": function ($event) {
                                $event.stopPropagation();
                              }
                            }
                          }, 'a', props, false), [_vm._v("Terms and Conditions")])];
                        }
                      }], null, true)
                    }, [_vm._v(" Opens in new window ")]), _vm._v(" and "), _c('v-tooltip', {
                      attrs: {
                        "location": "bottom"
                      },
                      scopedSlots: _vm._u([{
                        key: "activator",
                        fn: function (_ref8) {
                          var props = _ref8.props;
                          return [_c('a', _vm._b({
                            attrs: {
                              "href": "https://docs.google.com/document/d/1DBw9LVAuUwgz713037VQjsaD8sj2-AN_hzga_7kXtXI",
                              "target": "_blank"
                            },
                            on: {
                              "click": function ($event) {
                                $event.stopPropagation();
                              }
                            }
                          }, 'a', props, false), [_vm._v("Privacy Policy")])];
                        }
                      }], null, true)
                    }), _vm._v(" of the OpenCap tool. ")], 1)];
                  },
                  proxy: true
                }], null, true),
                model: {
                  value: _vm.edited_subject.terms,
                  callback: function ($$v) {
                    _vm.$set(_vm.edited_subject, "terms", $$v);
                  },
                  expression: "edited_subject.terms"
                }
              }, [_vm._v(" Opens in new window ")])];
            }
          }], null, true)
        })], 1)], 1), _c('v-card-actions', {
          staticClass: "px-4"
        }, [_c('v-spacer'), _c('v-btn', {
          attrs: {
            "color": "grey",
            "text": ""
          },
          on: {
            "click": function ($event) {
              return _vm.cancelSubjectForm();
            }
          }
        }, [_vm._v(" Cancel ")]), _c('v-btn', {
          attrs: {
            "color": "grey darken-4",
            "dark": "",
            "disabled": invalid
          },
          on: {
            "click": function ($event) {
              return _vm.submitSubjectForm();
            }
          }
        }, [_vm._v(" Save ")])], 1)], 1)], 1)];
      }
    }])
  })], 1), _c('v-dialog', {
    attrs: {
      "content-class": "confirm-dialog",
      "max-width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown
    },
    model: {
      value: _vm.low_weight_confirm_dialog,
      callback: function ($$v) {
        _vm.low_weight_confirm_dialog = $$v;
      },
      expression: "low_weight_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_vm._v("Confirm low subject weight")]), _c('v-card-text', [_vm._v(" The entered weight is " + _vm._s(_vm.lowWeightDisplayValue) + " " + _vm._s(_vm.weightUnitLabel) + ", which is lower than " + _vm._s(_vm.lowWeightThresholdDisplayValue) + " " + _vm._s(_vm.weightUnitLabel) + ". Please confirm this value is intentional before saving. ")]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "error darken-4",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.low_weight_confirm_dialog = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('v-btn', {
    attrs: {
      "color": "grey darken-4",
      "dark": ""
    },
    on: {
      "click": _vm.confirmAndSubmitLowWeight
    }
  }, [_vm._v("Confirm and save")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }